const triggerRouterCreateFxAlert = (sessionId, country, language, userData) => {
    const headersCreateFxAlert = new Headers();
    const countryUpperCase = country.toUpperCase();
    const uniqueId = `web-` + generateUniqueID();
    const uniqueIdCorrelation = `web-` + generateUniqueID();
    headersCreateFxAlert.append("x-wu-operationname", "createFxAlert");
    headersCreateFxAlert.append("Content-Type", "application/json");
    headersCreateFxAlert.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersCreateFxAlert.append("wucountrycode", countryUpperCase);
    headersCreateFxAlert.append("wulanguagecode", language);
    headersCreateFxAlert.append("x-wu-externalRefId", uniqueId);
    headersCreateFxAlert.append("x-wu-correlationId", uniqueIdCorrelation);
    headersCreateFxAlert.append("accept-language", `en-${countryUpperCase}`);
    headersCreateFxAlert.append("x-wu-sessionId", sessionId);
    headersCreateFxAlert.append("x-wu-apiKey", `1978`);

    let createFxAlertInput = {
              fxAlertType: "EMAIL",
              alert: {
                segment: "",
                payIn: userData.payIn,
                payOut: userData.payOut,
                destination: {
                  currencyIsoCode: userData.receiverCurrencyCode,
                  countryIsoCode: userData.receiverCountryCode
                },
                origination: {
                  countryIsoCode: userData.senderCountryCode,
                  currencyIsoCode: userData.senderCurrencyCode,
                  principalAmount: 10000
                }
              },
              email: userData.emailAddress,
              frequency: userData.frequency,
              threshold: userData.threshold,
               name: {
                first: ""
              },
              fxRateStrategy: "userSelected"    
    }
  
    
    const graphql = JSON.stringify({
      query: createFXAlertQuery,
      variables: {
        req: createFxAlertInput
      }
    })

    const requestOptions = {
      method: 'POST',
      headers: headersCreateFxAlert,
      body: graphql,
      redirect: 'follow'
    };
  
    return fetchApiWu(routerUrl, requestOptions, 'createFXAlertVulcan')
      .then(result => {
        return Promise.resolve({
            result
        })
      })
      .catch(error => console.log('Error in Create FX Alert call: ', error));
  
  }